// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_kt-0";
export var fulfillmentPanelBody = "_kt-1";